import Web3 from "web3";

export const bscWeb3 = new Web3(
  "https://data-seed-prebsc-1-s1.binance.org:8545"
);
